import MetadataHandler from "../../providers/handlers/MetadataHandler";
import FormElementMixin from "../../../../spine-appkit-vue/src/components/form/mixins/FormElementMixin";
import ComponentWithMetadataRelationMixin from "./mixins/ComponentWithMetadataRelationMixin";
import PlaceholderHandler from "../../providers/handlers/PlaceholderHandler";

Vue.asyncComponent('bp-metadata-control',{
    mixins: [ComponentWithMetadataRelationMixin, FormElementMixin],
    data() {
        return {
            doSelection: false,
            metadataHandler: null,
            placeholderHandler: null,
        }
    },
    props: {
        supportedMetadata: {
            typ: Array,
            required: true,
        },
        placeholderUrl: {
            type: String,
            required: false
        }
    },
    computed: {
        /**
         * Check if we need to render the relation resolver for this control
         * @returns {boolean}
         */
        renderRelationResolver() {
            let relation = this.getRelationStringObject();
            if(! relation) {
                return false;
            }

            const fieldId = relation.shift();

            if (fieldId === this.id) {
                return true;
            }

            return false;
        },
    },
    methods: {
        /**
         * Open the metadata selection
         */
        selectMetadata() {
            const relationAddon = this.id + ':selection' ;
            this.goToRoute(relationAddon);
        },
        /**
         * Go to metadata form
         * @param id
         */
        goToMetadataForm(metadata, index) {
            // If this metadata hasen't got any special settings we don't redirect to the form
            if (! metadata.settings.hasForm) {
                return;
            }

            const relationAddon = this.id + ':metadata-form:' + metadata.id + ':' + index;
            this.goToRoute(relationAddon);
        },
        /**
         * Remove a metadata item
         * @param metadataItemToRemove
         */
        removeMetadataItem(metadataItemToRemove) {
            const indexToDelete = this.currentValue.findIndex(metadataItem => metadataItem.id === metadataItemToRemove.id);
            this.currentValue.splice(indexToDelete, 1);
            this.metadataHandler.setMetadata(this.currentValue);
        },
        /**
         * Update metadata
         *
         * @param metaData
         */
        updateMetadata(metaData) {
            this.currentValue = metaData;
            this.metadataHandler.setMetadata(this.currentValue);
        },
        /**
         * Update the metadata item
         * @param id
         * @param settings
         * @returns {Promise<void>}
         */
        updateMetadataItem({id, settings}) {
            // get the full object
            const metadata = this.currentValue.find(metadata => metadata.id === id);
            // ad the new settings
            metadata.settings = settings;

            this.metadataHandler.setMetadata(this.currentValue);
        },
    },
    created() {
        this.placeholderHandler = this.placeholderUrl ?
            (new PlaceholderHandler(this.placeholderUrl)) :
            null;
        this.metadataHandler = (new MetadataHandler(this.currentValue));
        this.metadataHandler.setSupportedMetadata(this.supportedMetadata);
    }
}, 'blueprints/meta/bp-metadata-control.html');